<template>
  <div class="coupon__item d-flex flex-column flex-lg-row justify-content-between">
    <div>
      <span class="coupon__name"
        ><strong>{{ item.coupon.name }} ({{ item.coupon.code }})</strong></span
      >
      <span class="coupon__participant">
        {{ getParticipant }}
      </span>
    </div>

    <div class="coupon__price-wrapper d-flex justify-sm-content-between align-self-end">
      <span class="coupon__discount mr-3">
        {{ item.coupon.discount.amount | price(item.coupon.discount.currency) }}
      </span>
      <span class="coupon__remove" @click="removeCoupon(item)">
        <i class="fas fa-times-circle fa-sm remove-icon"></i> {{ $t('general.remove') }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as types from '@/types'

import { formatUserName } from '@/modules/profile/utilities/userName'
export default {
  name: 'BsiCouponListItem',
  props: ['item'],
  computed: {
    ...mapState({
      cart: state => state.cart.cart,
      profile: state => state.profile
    }),
    getParticipant() {
      return `${formatUserName(this.profile.user)} (${this.profile.userId})`
    }
  },
  methods: {
    removeCoupon(coupon) {
      this.$store.commit(types.REMOVE_COUPON, coupon)
      this.$noty.success(this.$t('coupon.remove.success'))
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon {
  &__item {
    margin-bottom: 15px;
  }

  &__name {
    font-style: italic;
  }

  &__participant {
    margin-right: 25px;

    @media (max-width: 576px) {
      display: block;
      margin: 10px 0;
    }
  }

  &__price-wrapper {
    margin-right: 35px;
  }

  &__remove {
    cursor: pointer;
    margin-left: 10px;

    &:hover {
      text-decoration: underline;
    }
  }

  &__discount {
    font-weight: bold;
  }
}
</style>
